module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('b-form', {
    staticClass: "mb-3",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.submitForm($event)
      }
    }
  }, [_c('action-buttons', {
    ref: "actionButtons",
    staticClass: "pull-right",
    attrs: {
      "disable-next": true,
      "disable-previous": true,
      "disable-save-and-new": true,
      "isDeleting": _vm.isDeleting,
      "delete-name": _vm.$t('bid.thisBid')
    },
    on: {
      "save": _vm.submitForm,
      "save-and-back": _vm.submitFormAndBack,
      "back": _vm.goBack,
      "delete": _vm.deleteBid
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "display-4"
  }, [_vm._v(_vm._s(_vm.$t('bid.edit')))]), _vm._v(" "), (_vm.formError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "warning"
    }
  }, _vm._l((_vm.formError.errors), function(errors) {
    return _c('span', _vm._l((errors), function(error) {
      return _c('span', [_vm._v(_vm._s(error)), _c('br')])
    }), 0)
  }), 0) : _vm._e(), _vm._v(" "), _c('partial-loader', {
    attrs: {
      "loading": _vm.isLoading
    }
  }), _vm._v(" "), (!_vm.isLoading) ? _c('div', [_c('b-jumbotron', {
    staticClass: "mb-3 p-4"
  }, [(_vm.bid.item) ? _c('h2', [_vm._v(_vm._s(_vm.$t('bid.itemBid')) + "\n\t\t\t\t\t\t"), _c('router-link', {
    attrs: {
      "to": {
        name: 'item',
        params: {
          itemId: _vm.bid.item.id
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.bid.item.seller.code) + "-" + _vm._s(_vm.bid.item.number) + " " + _vm._s(_vm.bid.item.title) + "\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), _c('p', [_c('small', [_vm._v("Aangemaakt op " + _vm._s(_vm._f("bigDate")(_vm.bid.created_at)))])]), _vm._v(" "), (_vm.bid.bid_number) ? _c('h2', {
    staticClass: "font-italic"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('bid.bidNumber')) + "\n\t\t\t\t\t\t"), _c('router-link', {
    attrs: {
      "to": {
        name: 'auctionBuyer',
        params: {
          bidNumber: _vm.bid.bid_number
        }
      }
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(_vm.bid.bid_number) + "\n\t\t\t\t\t\t")])], 1) : _vm._e(), _vm._v(" "), (_vm.bid.buyer == null) ? _c('p', {
    staticClass: "font-italic"
  }, [_vm._v("\n\t\t\t\t\t\t" + _vm._s(_vm.$t('bid.noBuyerForBidnumer')) + "\n\t\t\t\t\t")]) : _c('div', [_c('person-info', {
    attrs: {
      "person": _vm.bid.buyer.person
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Hamerbedrag:"
    }
  }, [_c('b-input-group', [_c('b-input-group-prepend', {
    attrs: {
      "is-text": ""
    }
  }, [_vm._v("\n\t\t\t\t\t\t\t\t\t€\n\t\t\t\t\t\t\t\t")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "type": "number",
      "step": "any",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.price),
      callback: function($$v) {
        _vm.$set(_vm.form, "price", $$v)
      },
      expression: "form.price"
    }
  })], 1)], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-4 col-lg-3"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Biednummer:"
    }
  }, [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "type": "text",
      "autocomplete": "off"
    },
    model: {
      value: (_vm.form.bid_number),
      callback: function($$v) {
        _vm.$set(_vm.form, "bid_number", $$v)
      },
      expression: "form.bid_number"
    }
  })], 1)], 1)], 1)])], 1) : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7b243d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Auction/Bid/BidForm.vue
// module id = 1312
// module chunks = 1